import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../../../../../@casino/ui/table';
import { setGetMailingStatisticsScrollerOpenGameByUser } from '../../../../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerOpenGameByUser';
import { format } from 'date-fns';
import { setGetMailingStatisticsScrollerOpenGameByUserAction } from '../../../../../../../../store/mailing/action';

const ScrollerOpenGame = ({
    login,
    mailing_id
}) => {
    const dispatch = useDispatch();
    const details = useSelector((state) => state.mailing.scrollers.open_game_by_user)

    const columns = [
        { id: 'created_at', label: 'Дата открытия'},
        { id: 'game_platform_uuid', label: 'Игра'},
    ];

    const handleChange = ({
        page,
        pageSize
    }) => {
        dispatch(setGetMailingStatisticsScrollerOpenGameByUser({
            mailing_id, 
            login, 
            page,
            pageSize
        }))
    }

    return (
        <div style={{width: '100%', margin: '10px 0 20px'}}>
            <TableCasino
                width={"100%"}
                pagination
                allPage={details?.[login]?.totalPage || 1}
                perPage={details?.[login]?.pageSize || 25}
                columns={columns}
                rows={details?.[login]?.list?.map((item) => ({
                    ...item,
                    created_at: format(new Date(Number(item.created_at)), 'dd.MM.yyyy HH:mm')
                })) || []}
                changePage={(v) => {
                    handleChange({
                        page: v.page + 1,
                        pageSize: v.rowsPerPage
                    })
                }}
                changeRowsPerPage={handleChange}
            />
        </div>
    )
}

export default ScrollerOpenGame;